export default __webpack_public_path__ + "static/media/3.8180e4e1.svg";